"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const auth0_react_1 = require("@auth0/auth0-react");
const mobx_1 = require("mobx");
const mobx_react_1 = require("mobx-react");
const react_1 = __importDefault(require("react"));
const AuthorizationScopes_1 = __importDefault(require("../../../common/js/enums/AuthorizationScopes"));
const translation_1 = require("../../../common/js/helper/translation");
const withAuthorization_1 = __importDefault(require("../../../common/js/hoc/withAuthorization"));
const UserProfileAddress_1 = __importDefault(require("../../atoms/UserProfileAddress"));
const ManufacturerAddress_1 = require("../../constants/ManufacturerAddress");
const AddressDisplayTypes_1 = __importDefault(require("../../enums/AddressDisplayTypes"));
const MassiveCompany_1 = __importDefault(require("../../stores/MassiveCompany"));
class UserProfileContacts extends react_1.default.Component {
    constructor(props) {
        super(props);
        (0, mobx_1.makeObservable)(this, {
            renderServiceOrganization: mobx_1.computed,
        });
    }
    componentDidMount() {
        document.title = (0, translation_1.t)('profile_subpage_title', { title: (0, translation_1.t)('user.profile.contacts.title') });
        MassiveCompany_1.default.loadCompany();
    }
    get renderServiceOrganization() {
        return !this.massiveAddressesAreEqual(MassiveCompany_1.default.company?.salesOrganizationMassiveAddress, MassiveCompany_1.default.company?.serviceOrganizationMassiveAddress);
    }
    render() {
        const company = MassiveCompany_1.default.company;
        return (react_1.default.createElement("section", { className: "znd-user-profile-page__content" },
            react_1.default.createElement("h2", { className: "znd-user-profile-page__content-data-title t-headline-3" }, (0, translation_1.t)('user.profile.local_contacts')),
            react_1.default.createElement("div", { className: "znd-user-profile-page__content-data-group" },
                !!company?.salesOrganizationMassiveAddress ? (react_1.default.createElement(UserProfileAddress_1.default, { className: "znd-user-profile-page__content-data-item", title: (0, translation_1.t)('user.profile.local_contact'), address: company?.salesOrganizationMassiveAddress, displayType: AddressDisplayTypes_1.default.small, sendDataLayerContactValue: true })) : null,
                !!company?.serviceOrganizationMassiveAddress && this.renderServiceOrganization ? (react_1.default.createElement(UserProfileAddress_1.default, { className: "znd-user-profile-page__content-data-item", title: (0, translation_1.t)('user.profile.service_organisation'), address: company?.serviceOrganizationMassiveAddress, displayType: AddressDisplayTypes_1.default.small, sendDataLayerContactValue: true })) : null,
                react_1.default.createElement(UserProfileAddress_1.default, { className: "znd-user-profile-page__content-data-item", title: (0, translation_1.t)('user.profile.manufacturer'), address: ManufacturerAddress_1.MANUFACTURER_ADDRESS, displayType: AddressDisplayTypes_1.default.small, sendDataLayerContactValue: true }))));
    }
    massiveAddressesAreEqual(firstAddress, secondAddress) {
        if (!firstAddress || !secondAddress) {
            return false;
        }
        return (firstAddress.name1 === secondAddress.name1 &&
            firstAddress.street === secondAddress.street &&
            firstAddress.zipcode === secondAddress.zipcode &&
            firstAddress.city === secondAddress.city &&
            firstAddress.countryId === secondAddress.countryId &&
            firstAddress.email === secondAddress.email &&
            firstAddress.phoneNumber === secondAddress.phoneNumber);
    }
}
exports.default = (0, auth0_react_1.withAuth0)((0, withAuthorization_1.default)({ scope: AuthorizationScopes_1.default.COMPANY_READ })((0, mobx_react_1.observer)(UserProfileContacts)));
